let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dyYGo")).then(() => parcelRequire('9mahg'));